{{#each this}}
  <li class='list-item'>
    <p class='ingridient'>{{name}}</p>

    <p class='portion'>{{measure}}</p>
  </li>
{{/each}}